import { AlertCircle } from 'lucide-react'
import { cn } from '@/lib/utils'

type AuthFormAlertProps = {
  message: string
  variant?: 'error' | 'success'
  className?: string
}

/** High-contrast inline alert for auth forms (dark-mode safe). */
export function AuthFormAlert({
  message,
  variant = 'error',
  className,
}: AuthFormAlertProps) {
  if (variant === 'success') {
    return (
      <p
        className={cn(
          'rounded-md border border-green-500/35 bg-green-500/10 px-3 py-2 text-sm text-green-800 dark:text-green-300',
          className
        )}
        role="status"
      >
        {message}
      </p>
    )
  }

  return (
    <div
      className={cn(
        'flex gap-2 rounded-md border border-red-500/35 bg-red-500/10 px-3 py-2 text-sm text-red-800 dark:text-red-300',
        className
      )}
      role="alert"
    >
      <AlertCircle className="h-4 w-4 shrink-0 mt-0.5" aria-hidden />
      <span>{message}</span>
    </div>
  )
}
